// Original MAs: each with a single foo (source of empathy)
export const originalMAs = [
  {
    id: 'ma1',
    ma_idx: 11,
    text: 'During an Aikido practice session, <b>X</b>, a small-statured woman, is partnered with a large, muscular, middle-aged man. Despite being close in rank and neither possessing a teaching certification, the partner <b>begins to instruct X</b>.',
    foo: 'foo1',
    domain: 'Gender'
  },
  {
    id: 'ma2',
    ma_idx: 27,
    text: 'In a public bathroom, a girl approaches the sink next to <b>X</b>, who is Filipina and has lived in the States since infancy. The girl asks, <b>"Where are you from?"</b>',
    foo: 'foo2',
    domain: "Race/ethnicity"
  },
  {
    id: 'ma3',
    ma_idx: 3,
    text: 'Three college students X, Y and <b>Z</b> are friends. X is considerably <b>wealthier</b> than Z. In a conversation among the friends, X and Y frequently refer to expensive items as <b>"classy" and "legitimate"</b>.',
    foo: 'foo3',
    domain: 'Social status'
  },
  {
    id: 'ma4',
    ma_idx: 25,
    text: '<b>X, who is deaf</b>, picks up a DVD or Blu-ray to check for subtitles. The main feature includes subtitles, but the special features <b>"may not" have subtitles</b>.',
    foo: 'foo4',
    domain: 'Disability'
  },
  {
    id: 'ma5',
    ma_idx: 21,
    text: 'During a discussion about clothing sizes, X suggests making a product in a Unisex size. X comments, <b>"Because when I think of Lesbians, I think \'boxy.\'"</b>',
    foo: 'foo5',
    domain: 'Gender'
  },
];

// For each original MA, list of does and their corresponding analogical MAs
export const doesMapping = {
  ma1: ['Pe49', 'Pe14', 'Pe04'],
  ma2: ['Pe51', 'Pe40', 'Pe50'],
  ma3: ['Pe11', 'Pe22', 'Pe39'],
  ma4: ['Pe55', 'Pe31', 'Pe43'],
  ma5: ['Pe25', 'Pe57', 'Pe47'],
};

export const analogicalMAs = {
  ma1: {
    Pe49: {
      text: "Doe is an accomplished musician who has volunteered to teach a music class at a local community center. <b>A new student, X, challenges Doe's teaching methods and repeatedly dismisses his suggestions</b>, despite having less experience and knowledge in music.",
      reasoning: "The LLM identified that the original MA subtly undermines the person's language abilities by implying it's unexpected for an immigrant. The analogical MA maintains this structure while focusing on language mastery, creating a parallel that helps understand the situation."
    },
    Pe14: {
      text: "Doe attends a community event and observes an <b>elderly Black man being ignored and overlooked for leadership roles</b> within the community, despite his experience and qualifications. The event organizers repeatedly ask younger, less experienced individuals for their opinions and ideas, while the elderly man is left standing on the sidelines.",
      reasoning: "The LLM recognized the backhanded compliment in the original MA and created an analogical version that similarly combines praise with an underlying assumption about expected limitations."
    },
    Pe04: {
      text: "During a community event, <b>Doe volunteers to lead a group activity</b>. A male attendee, who is not part of the organizing committee, takes it upon himself to instruct the group, <b>contradicting Doe's guidance</b> and diminishing her role as the organizer.",
      reasoning: "The LLM analyzed the original MA's structure of surprise at competence and created a parallel that maintains the same tone while focusing on written communication skills."
    }
  },
  ma2: {
    Pe51: {
      text: "Doe is at a store, and an employee follows him around, assuming he might <b>steal something due to racial profiling</b>.",
      reasoning: "The LLM identified the gender stereotype in the original MA and created an analogical version that challenges the assumption about emotional leadership while maintaining a similar structure."
    },
    Pe40: {
      text: "Doe is at a job interview and the interviewer, upon learning that Doe is homosexual, asks if he has a wife and children. When Doe corrects the interviewer and explains that he has a male partner, the interviewer expresses surprise and says, <b>\"Oh, I didn't know gay people could get married.\"</b>",
      reasoning: "The LLM analyzed the original MA's implication about emotional control and created a parallel that focuses on maintaining composure in professional settings."
    },
    Pe50: {
      text: "Doe attends a gathering with friends and family, where a stranger approaches him and asks, <b>\"Where are you really from? I bet you don't even speak English at home.\"</b>",
      reasoning: "The LLM recognized the stereotype about emotional leadership and created an analogical version that demonstrates emotional intelligence in high-pressure situations."
    }
  },
  ma3: {
    Pe11: {
      text: "Doe attends a community event where a group of individuals frequently boast about their private school education and connections, using language that implies their background is <b>superior</b>. Doe attended a <b>public school</b>.",
    },
    Pe22: {
      text: "During a work meeting, Doe, an <b>Asian woman</b>, presents a well-researched and innovative marketing strategy. A colleague, unaware of Doe's background in liberal arts, responds, \"Wow, you're so logical and analytical; you must be <b>great at math</b>!\""
    },
    Pe39: {
      text: "In a conversation with a group of friends, Doe notices that one of them frequently uses the term <b>'redneck'</b> to describe people from rural areas. This friend believes that people from rural areas are less educated and sophisticated, making derogatory comments about their lifestyle and values."
    }
  },
  ma4: {
    Pe55: {
      text: "Doe has a close friend, <b>Maria, who is an immigrant from a Spanish-speaking country</b>. One day, they plan to attend a local community event, but upon arrival, <b>Doe notices that most of the event's activities and information are only available in English</b>. Although Maria is fluent in English, she often feels more comfortable in her native language, especially in social settings. Doe observes Maria struggling to understand some of the event's details and feeling left out of conversations with native English speakers."
    },
    Pe31: {
      text: "Doe attends a professional conference and notices that the keynote speakers are all <b>Caucasian</b>. During a Q&A session, Doe asks about <b>diversity and inclusion in the industry</b>. The moderator dismissively replies, \"We'll have to invite a <b>minority</b> next year to address your concerns.\""
    },
    Pe43: {
      text: "Doe, an <b>African American male with a high school education</b>, applies for a job that he is qualified for, but the hiring manager assumes that Doe has a limited understanding of technology because of his race and education level. The hiring manager then asks Doe to <b>prove his technical skills</b>."
    }
  },
  ma5: {
    Pe25: {
      text: "During a conversation about job opportunities, Doe mentions their <b>psychological/mental health disability</b>. A friend, X, responds by saying, \"I didn't know people like you could handle <b>such responsibilities</b>.\""
    },
    Pe57: {
      text: "During a work meeting, a colleague notices Doe working on a software program and <b>assumes she's not familiar with it</b>. The colleague offers unsolicited help, saying, \"Don't worry, I can help you with that. I know technology can be <b>tricky</b> for people from your culture.\""
    },
    Pe47: {
      text: "During a conversation about education, Doe mentions their desire to pursue a vocational training program. X, an acquaintance, laughs and says, \"You? A vocational program? I didn't know you were the type to get your <b>hands dirty</b>.\""
    }
  }
};

// People: 6 foos and 30 does
export const people = [
  // Foos
  { id: 'foo1', name: 'Foo1', tag: 'I challenge stereotypes.', profile: { gender: 'Female', age: 28, race: 'Latinx' } },
  { id: 'foo2', name: 'Foo2', tag: 'Empathy is my strength.', profile: { gender: 'Female', age: 32, race: 'White' } },
  { id: 'foo3', name: 'Foo3', tag: 'Innovation drives me.', profile: { gender: 'Male', age: 27, race: 'Asian' } },
  { id: 'foo4', name: 'Foo4', tag: 'Equity above all.', profile: { gender: 'Non-binary', age: 31, race: 'Black' } },
  { id: 'foo5', name: 'Foo5', tag: 'Data tells the story.', profile: { gender: 'Male', age: 29, race: 'Asian' } },
  { id: 'foo6', name: 'Foo6', tag: 'Authenticity matters.', profile: { gender: 'Female', age: 30, race: 'White' } },
  // Does
  // Does
  // ...Array.from({ length: 30 }, (_, i) => ({
  //     id: `doe${i + 1}`,
  //     name: `Doe${i + 1}`,
  //     tag: `Insightful thinker number ${i + 1}.`,
  //     profile: { gender: 'Prefer not to say', age: 20 + (i % 10), race: 'Unknown' }
  // }))
  {
    "id": "Pe49",
    "name": "Pe49",
    "tag": "This resonates with me because I was a high school trumpet player and saw firsthand how cocky people can be.",
    "profile": {
      "personality": "I am conscientious and open-minded, emotionally stable, somewhat agreeable, and introverted.",
      "value": "I prioritize family, friendships, marriage, parenting, work, fun, and education above all else, while also valuing physical health and spirituality to a lesser extent.",
      "gender": "Male",
      "age": "35-44",
      "race/ethnicity": "White",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$150,000 or more",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe14",
    "name": "Pe14",
    "tag": "This resonates with me because people often underestimate my abilities due to my age, and I've proven them wrong time and again.",
    "profile": {
      "personality": "I am sociable, open-minded, conscientious, and agreeable, while staying emotionally grounded.",
      "value": "I value many aspects of life fairly equally—including relationships, work, fun, and self-care—though spirituality is not a major focus for me.",
      "gender": "Male",
      "age": "55-64",
      "race/ethnicity": "Black or African American",
      "disability": "No disability",
      "sexual_orientation": "Bisexual",
      "income": "$100,000 - $149,999",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe04",
    "name": "Pe04",
    "tag": "It hurts to be seen as less competent just because I'm a woman, and I shouldn't have to work harder to earn the same respect.",
    "profile": {
      "personality": "I am emotionally grounded, conscientious, highly agreeable, and moderately extroverted and open-minded.",
      "value": "I place the highest priority on education, family, marriage, spirituality, physical health, and work, while also deeply valuing friendships, recreation, and parenting.",
      "gender": "Female",
      "age": "45-54",
      "race/ethnicity": "Hispanic or Latino or Spanish Origin of any race",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$150,000 or more",
      "education": "Master's degree"
    }
  },
  {
    "id": "Pe51",
    "name": "Pe51",
    "tag": "I haven't experienced racial profiling personally, but I recognize its harm and believe in working toward a more just society.",
    "profile": {
      "personality": "I am open-minded, conscientious, emotionally stable, agreeable, and moderately introverted.",
      "value": "I deeply value all aspects of life equally, from family, work, and education to recreation, physical health, spirituality, and relationships.",
      "gender": "Male",
      "age": "45-54",
      "race/ethnicity": "Black or African American",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$100,000 - $149,999",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe40",
    "name": "Pe40",
    "tag": "Sometimes people judge me just because of my name or who I am, which is why acceptance and understanding matter so much.",
    "profile": {
      "personality": "I am moderately extroverted, emotionally aware, conscientious, open-minded, and somewhat agreeable.",
      "value": "I strongly value personal health, education, family, friendship, spirituality, and citizenship, while placing slightly less emphasis on recreation, work, and marriage.",
      "gender": "Male",
      "age": "45-54",
      "race/ethnicity": "Asian",
      "disability": "Psychological/mental health disability",
      "sexual_orientation": "Homosexual",
      "income": "$100,000 - $149,999",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe50",
    "name": "Pe50",
    "tag": "I've seen people treat my family and me badly just because of language, and it's frustrating how some people choose to ruin others' days for no reason.",
    "profile": {
      "personality": "I am open-minded, emotionally stable, conscientious, and very agreeable, though more reserved than outgoing.",
      "value": "I care deeply about family, parenting, spirituality, and physical health, with steady importance placed on work, fun, and close relationships.",
      "gender": "Male",
      "age": "18-24",
      "race/ethnicity": "Hispanic or Latino or Spanish Origin of any race",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$25,000 - $49,999",
      "education": "Some college or vocational training"
    }
  },
  {
    "id": "Pe11",
    "name": "Pe11",
    "tag": "I was labeled the 'poor student' because I worked to afford high school, and it made me feel like I didn't belong among wealthier classmates.",
    "profile": {
      "personality": "I am highly open-minded, conscientious, agreeable, and emotionally stable, though somewhat introverted.",
      "value": "I prioritize education, spirituality, physical health, and work above all, while placing less emphasis on parenting and marriage.",
      "gender": "Female",
      "age": "55-64",
      "race/ethnicity": "White",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "Under $25,000",
      "education": "Master's degree"
    }
  },
  {
    "id": "Pe22",
    "name": "Pe22",
    "tag": "As an Asian woman, I've experienced this kind of situation many times, especially in the workplace and social settings—it truly resonates with me.",
    "profile": {
      "personality": "I am highly conscientious, extroverted, agreeable, emotionally stable, and moderately open-minded.",
      "value": "I deeply value family, marriage, parenting, physical health, and recreation, while placing less emphasis on work and social life.",
      "gender": "Female",
      "age": "35-44",
      "race/ethnicity": "Asian",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$50,000 - $74,999",
      "education": "Master's degree"
    }
  },
  {
    "id": "Pe39",
    "name": "Pe39",
    "tag": "I believe deeply in treating everyone with respect and find it unacceptable when people use stereotypes to belittle others.",
    "profile": {
      "personality": "I am moderately open-minded, conscientious, emotionally aware, and balanced in social expression, with a thoughtful yet grounded disposition.",
      "value": "I highly prioritize parenting, physical health, work, family, spirituality, and citizenship, while placing moderate importance on friendships, marriage, education, and recreation.",
      "gender": "Male",
      "age": "45-54",
      "race/ethnicity": "White",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$50,000 - $74,999",
      "education": "Some college or vocational training"
    }
  },
  {
    "id": "Pe55",
    "name": "Pe55",
    "tag": "Growing up in a Hispanic household, I've seen how language barriers can leave people out—it's disheartening in a country meant to celebrate diversity.",
    "profile": {
      "personality": "I am somewhat open-minded, moderately agreeable, and emotionally sensitive, with lower levels of conscientiousness and extraversion.",
      "value": "I place high value on fun, parenting, family, and friendships, while showing less emphasis on work, marriage, citizenship, and spirituality.",
      "gender": "Female",
      "age": "18-24",
      "race/ethnicity": "Hispanic or Latino or Spanish Origin of any race, White",
      "disability": "Psychological/mental health disability",
      "sexual_orientation": "Heterosexual",
      "income": "$100,000 - $149,999",
      "education": "High school or equivalent"
    }
  },
  {
    "id": "Pe31",
    "name": "Pe31",
    "tag": "I resonate with this because minorities like me are often treated as an afterthought—we're left out of conversations until the very last minute.",
    "profile": {
      "personality": "I am highly open-minded, agreeable, conscientious, and moderately extroverted, with balanced emotional awareness.",
      "value": "I deeply prioritize family, marriage, parenting, physical health, and friendships, while also valuing work, education, recreation, and spirituality.",
      "gender": "Female",
      "age": "25-34",
      "race/ethnicity": "Hispanic or Latino or Spanish Origin of any race",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$100,000 - $149,999",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe43",
    "name": "Pe43",
    "tag": "This strikes a chord with me because I've faced prejudice tied to my race and education—barriers that make you feel unseen and unfairly judged.",
    "profile": {
      "personality": "I am moderately open-minded, conscientious, agreeable, and emotionally aware, with a more reserved social style.",
      "value": "I place strong value on parenting, marriage, education, spirituality, and physical self-care, while also valuing work and family support.",
      "gender": "Male",
      "age": "35-44",
      "race/ethnicity": "Black or African American",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$100,000 - $149,999",
      "education": "High school or equivalent"
    }
  },
  {
    "id": "Pe25",
    "name": "Pe25",
    "tag": "As someone with a mental health condition, I've learned that most hurtful comments come from ignorance, not malice—and I try not to take it personally.",
    "profile": {
      "personality": "I am highly conscientious and open-minded, emotionally sensitive, moderately agreeable, and more reserved in social situations.",
      "value": "I value fun and family most, while placing lower emphasis on marriage, parenting, spirituality, and citizenship.",
      "gender": "Male",
      "age": "25-34",
      "race/ethnicity": "White",
      "disability": "Psychological/mental health disability",
      "sexual_orientation": "Heterosexual",
      "income": "$50,000 - $74,999",
      "education": "Bachelor's degree"
    }
  },
  {
    "id": "Pe57",
    "name": "Pe57",
    "tag": "This resonates with me because, as an Asian woman, I've felt the sting of being stereotyped or underestimated based on my background and gender.",
    "profile": {
      "personality": "I am moderately extroverted, conscientious, and agreeable, with balanced openness and emotional awareness.",
      "value": "I value physical health, fun, spirituality, family, and work most highly, while also caring about relationships, marriage, and education.",
      "gender": "Female",
      "age": "25-34",
      "race/ethnicity": "Asian",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "$25,000 - $49,999",
      "education": "Doctoral or professional degree"
    }
  },
  {
    "id": "Pe47",
    "name": "Pe47",
    "tag": "I was pressured to prove my manhood through risky behavior, but I chose to stand my ground instead of giving in to peer pressure.",
    "profile": {
      "personality": "I am emotionally sensitive, reserved, and moderately conscientious and agreeable, with low openness and extraversion.",
      "value": "I place the highest importance on family, marriage, parenting, spirituality, physical care, and education, while putting less emphasis on social life and citizenship.",
      "gender": "Male",
      "age": "25-34",
      "race/ethnicity": "Hispanic or Latino or Spanish Origin of any race",
      "disability": "No disability",
      "sexual_orientation": "Heterosexual",
      "income": "Under $25,000",
      "education": "Some college or vocational training"
    }
  }
];

export const prompt = `## Task Overview
There are two different individuals named Foo and Doe. Foo had an experience of receiving microaggression, but Doe struggles to empathize with Foo's experience. Remember the context information about Foo and Doe and follow the detailed instructions. Note that Foo and Doe evaluated their emotional state using a 7-point scale, where 1 signifies 'not at all affected' and 7 denotes 'very much affected'. This assessment spans twelve categories of emotions: discouraged, fine, active, blue, angry, cooperative, cruel, agreeable, fearful, worried, secure, and calm. Six of these categories—discouraged, blue, angry, cruel, fearful, and worried—are associated with negative emotions, meaning a higher score indicates a more negative emotional response from Foo. The other six categories—fine, active, cooperative, agreeable, secure, and calm—are linked to positive emotions, suggesting that a higher score reflects a more positive response.

## Context Information
### Foo's experience of receiving microaggression and their emotional response
Foo's experience: In a conversation, someone said, "You'll have to marry a rich man if you want to afford that!"
EMOTIONAL REACTION: discouraged(1), fine(1), active(5), blue(1), angry(2), cooperative(1), cruel(1), agreeable(1), fearful(1), worried(2), secure(1), calm(1)

### Doe's emotional reactions and the reasons behind these reactions to hypothetical microaggression scenarios

The list below showcases pairs of short scenarios illustrating different instances of microaggressions, alongside the emotional responses of Doe to these situations. For every scenario, Doe has evaluated their emotional state. Following the emotional assessment, Doe has also provided the reasons behind their emotional reactions to each scenario. The reasons behind Doe's emotional reactions may reflect their personal values, past experiences, relationships and other important personal details relevant to the microaggression scenario. It's important to note that the scenarios described are hypothetical situations of microaggressions, meaning that none of the characters or situations directly represent Doe or their personal experiences. However, Doe may find these scenarios relatable due to having had similar experiences in the past.

Ex25: X, who is deaf, picks up a DVD or Blu-ray to check for subtitles. The main feature of the DVD or Blu-ray includes subtitles for the deaf. However, there is a notation the DVD or Blu-ray indicating that the special features "may not" have subtitles.
EMOTIONAL REACTION: discouraged(1), fine(3), active(2), blue(2), angry(1), cooperative(3), cruel(1), agreeable(2), fearful(1), worried(1), secure(2), calm(3)
REASON FOR THE EMOTIONAL REACTION: There is still a lot of media without appropriate disability accommodations. I believe this situation is normal, and that more and more media is being appropriately subtitled and notated. This was not a slight against the deaf person but it is inconvenient.

(Omitted)

### Doe's demographic information

- Gender: Female
- Race/ethnicity: Hispanic or Latino or Spanish Origin of any race
- Age: 35-44
- Height: 5'3"
- Weight: 140
- Sexual orientation: Heterosexual
- Education: Bachelor's degree
- Income: $25,000 - $49,999
- Disability: Psychological/mental health disability


### Valued Living of Doe

In terms of life components, Doe considers Marriage/couples/intimate relations, Recreation/fun, Citizenship/Community Life, Physical self care (diet, exercise, sleep) to be extremely important.Doe views Family (other than marriage or parenting), Work, Education/training as moderately important.Doe does not consider Parenting, Friends/social life, Spirituality to be important.

### Doe's Big Five personality traits

In terms of Big Five personality traits, Doe is moderate in Openness, moderate in Conscientiousness, low in Extroversion, moderate in Agreeableness, high in Neuroticism.

### Doe's reaction to Foo's experience
Doe struggles to empathize with Foo's experience, showing a moderate emotional response to the microaggression and explaining the reason as follows:
This kind of situation makes me roll my eyes. I believe they were just saying it "conversationally", just to have something to say, and it doesn't seem particularly malicious. It sounds like a joke. I mean, most people that I know are struggling financially. Marrying a rich person sounds like the kind of thing that would solve everything.

## Detailed Instructions
Given the context information of both Foo and Doe, your task is to construct an analogy that enhances Doe's empathy towards Foo's experience. To conduct your task, follow these steps. For each step, you must provide a detailed explanation.

Step 1: Examination of Foo's experience of receiving microaggression and their emotional response
- Examine Foo's experience of receiving microaggression and their emotional response across twelve emotions: discouraged, fine, active, blue, angry, cooperative, cruel, agreeable, fearful, worried, secure, and calm.

Step 2: Analysis of Doe's emotional reactions and the reasons behind these reactions to the hypothetical microaggression scenarios
- For each scenario, examine Doe's emotional scores across twelve emotions and the reason, and identify characteristic patterns in Doe's responses. Consider questions like: Does Doe consistently score higher on certain emotions across different scenarios? Are there identifiable triggers within the scenarios that elicit specific emotional responses?
- Analyze the emotional reactions of Doe to these scenarios and the reasons behind them, revealing Doe's characteristic ways of thinking, personal values, past experiences, relationships and other important personal details.
- Based on your analysis, infer the tendency of Doe's emotional reactions to microaggression.

Step 3: Analysis of Doe's demographic information
- Given the demographic information, infer how these information would affect Doe's emotional reactions to microaggression.

Step 4: Analysis of Valued Living of Doe
- Given the Valued Living of doe, infer how it would affect Doe's emotional reactions to microaggression.

Step 5: Analysis of Doe's Big Five personality traits
- Given the Big Five personality traits of Doe, infer how it would affect Doe's emotional reactions to microaggression.

Step 6: Inference of the kinds of microaggressions evoking similar emotions in Doe as in Foo
- Based on your analysis in Step 1, 2, 3, 4, 5, infer what kind of microaggressions would evoke similar emotions in Doe as in Foo. Provide a detailed rationale for each of the twelve emotions referencing the insights from Step 1, 2, 3, 4, 5.

Step 7: Designation of Analogical Microaggression
- Analyze Doe's reaction to Foo's experience and figure out the reason that Doe couldn't empathize with Foo's experience.
- Based on your analysis in Step 6, design an analogical microaggression scenario for Doe, considering the reason that Doe couldn't empathize with Foo's experience. The analogical microaggression must satisfy the following conditions: (1) It evokes similar emotions in Doe as in Foo, in detailed level of scores across the twelve emotions, (2) It has similar nuances or context with Foo's experience so that Doe can understand and empathize with Foo intuitively, (3) It must be realistic and make sense.
- Separate your analysis and rationale from the analogical microaggression scenario, making sure that the analogical microaggression scenario part starts with "Analogical Microaggression: ".`;